/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_History_DescInputs */

const es_privacy_policy_retention_history_desc = /** @type {(inputs: Privacy_Policy_Retention_History_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenado temporalmente (max 24 horas de inactividad). Ningun historial se almacena permanentemente asociado a su identidad.`)
};

const en_privacy_policy_retention_history_desc = /** @type {(inputs: Privacy_Policy_Retention_History_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stored temporarily (max 24 hours of inactivity). No history is permanently stored associated with your identity.`)
};

/**
* | output |
* | --- |
* | "Stored temporarily (max 24 hours of inactivity). No history is permanently stored associated with your identity." |
*
* @param {Privacy_Policy_Retention_History_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_history_desc = /** @type {((inputs?: Privacy_Policy_Retention_History_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_History_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_history_desc(inputs)
	return en_privacy_policy_retention_history_desc(inputs)
});
export { privacy_policy_retention_history_desc as "privacy_policy.retention.history_desc" }